import { BodyText, Link } from '@paypalcorp/pp-react'
import PageMessage from 'ppbl/components/PageMessage'
import { useApplicationContext } from 'ppbl/hooks'
import { trackClick, trackPage } from 'ppbl/utils/fpti-helper'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'
import { merge } from 'lodash-es'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { interpolate } from 'ppbl/utils/string-helper'
import { isRenewalFlow, getPortalUrl } from 'ppbl/screens/__utils__'
import React, { useEffect } from 'react'
import clientLogger from 'ppbl/utils/client-logger'
import { CaseTypes, creditFrozenPageConstants } from 'ppbl/utils/constants'

const fptiData = {
  page: 'creditFrozenPage',
  event_name: FPTI_EVENTS.PAGE.CREDIT_FROZEN,
}

type Props = {
  applicationType: string
}

const CreditFrozenPage: React.FC<Props> = ({ applicationType }) => {
  const { data } = useApplicationContext()
  const portalInfo = data?.applicationMetaData?.portalAccess

  useEffect(() => {
    clientLogger.info(
      'Credit Frozen page is loaded - Application ID:',
      data?.applicationMetaData?.applicationId,
    )
    trackPage(
      merge(fptiData, {
        applicationId: data?.applicationMetaData?.applicationId,
      }),
    )
  }, [])

  const handleContinueToPortalClick = function () {
    trackClick(
      merge(fptiData, {
        component: `continueToPortal_creditFrozenPage_button`,
        link: `continueToPortal_creditFrozenPage_button`,
        applicationId: data?.applicationMetaData?.applicationId,
        event_name: FPTI_EVENTS.CLICK.NAVIGATION.CONTINUE_TO_PORTAL,
      }),
    )
    const portalUrl = getPortalUrl(portalInfo, CaseTypes.CREDIT_BUREAU_FROZEN)
    window.open(portalUrl, '_self')
    sessionStorage.setItem('mostRecentCompletedPage', 'credit-frozen')
  }

  return (
    <PageMessage
      type="warning"
      onPrimaryAction={
        isRenewalFlow(applicationType) && handleContinueToPortalClick
      }
      localization={{
        title: getLocalizedText('creditFrozen-page.title'),
        primaryText: getLocalizedText(`creditFrozen-page.continueBtn`),
      }}
    >
      <BodyText className="body__text">
        {interpolate(getLocalizedText('creditFrozen-page.bodyText1.text'), {
          transUnion: (
            <Link
              href={getLocalizedText('creditFrozen-page.bodyText1.href')}
              size="md"
              secondary
            >
              {getLocalizedText('creditFrozen-page.bodyText1.link')}
            </Link>
          ),
          phone: (
            <Link
              href={creditFrozenPageConstants.phoneNumber1.tel}
              size="md"
              secondary
            >
              <br />
              {creditFrozenPageConstants.phoneNumber1.phone}
            </Link>
          ),
        })}
        <br />
        <br />
        {interpolate(getLocalizedText('creditFrozen-page.bodyText2.text'), {
          phone: (
            <Link
              href={creditFrozenPageConstants.phoneNumber2.tel}
              size="md"
              secondary
            >
              {creditFrozenPageConstants.phoneNumber2.phone}
            </Link>
          ),
        })}
      </BodyText>
    </PageMessage>
  )
}

export default CreditFrozenPage
